import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Collapsable,
} from '../../../components';


import './style.scss';

const ParagraphCheckList = ({ entity }) => {
  const items = entity.get('field_item');
  const title = entity.getIn(['field_title', 0, 'value']);
  const variant = entity.getIn(['field_variant', 0, 'value']);

  return (
    <Container className="Paragraph ParagraphCheckList">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <div className={`ParagraphCheckList__inner ${variant && `color color--${variant}`}`}>
            {title && <h3>{title}</h3>}
            {items && items.size > 0 && (
              items.map((item, index) => {
                const itemTitle = item.getIn(['entity', 'field_title', 0, 'value']);
                const itemBody = item.getIn(['entity', 'field_body', 0, 'processed']);
                const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
                return (
                  <Collapsable key={uuid} title={itemTitle} body={itemBody} index={index} />
                );
              })
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ParagraphCheckList;
